import React, { useState, useContext } from "react";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  addActiveFn,
  pushToParams,
  withNewTitleAndName,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import request from "../../services/request";
import { formatListWithParameter, formatShortDate, truncateText } from "../../utils";
import DemandUpdate from "./demand-update/DemandUpdate";
import { useTranslation } from "react-i18next";
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import { Field } from "formik";
import Select from "../../components/form-fields/Select"; /* Added Line */
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import TextInput from "../../components/form-fields/TextInput";
import { ThemeContext } from '../../../context/ThemeContext';



export default function PendingDemands(props) {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [t, i18n] = useTranslation(); /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("");
  const [filters, setFilters] = useState([]);
  const [configData, setConfigData] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  // const [isSubsidiary, setIsSubsidiary] = useState(true);


  const ikiliFormat = new URLSearchParams(props.location.search).get('ikiliFormat');

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onReject = () => {
    onUpdateButtonClicked(selectedRow);
    request({
      url: "yonlendirilecek-talep/reddet",
      method: "POST",
      data: {
        body: {
          id: selectedRow.id,
          redNedeni: rejectReason,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setRefreshList(!refreshList);
        setShowModal(false);
      }
    });
  };

  // const filterCompanies = (companies) => {
  //   if (isSubsidiary === 1)
  //     return companies.filter(company => company.yurtici === true);
  //   return companies;
  // }
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };
  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="0"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">                  
                  <Filters
                    configPointUrl="raporlar/config"
                    // configParameterName="talepTurId"
                    // configParameterValue={16}
                    // configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    {/* <Field
                      name="filtreTuru"
                      label={`${t("demandUpdate.talepFiltrele")}`}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.filtreTurleri}
                    /> */}
                    {/* <Field
                      name="groupID"
                      label={t("davaIcraSavcilik.grup")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.grupSirketleri}
                    /> */}
                    <Field
                        name="yurtici"
                        label={t("demandList.yurtici")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.yurtici}
                    />
                    <Field
                        name="sirketDurumu"
                        label={t("demandList.sirketDurumu")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.sirketDurumu}
                    />
                    <Field
                        name="isSubsidiary"
                        label={t("demandList.istirakSirketleri")}
                        colNumber="3"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.isSubsidiary}
                        // onChangeFunc={(opt) => setIsSubsidiary(opt)}
                    />
                    <Field
                      name="sirketID"
                      label={t("davaIcraSavcilik.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      // options={configData && filterCompanies(configData.sirketler)}
                      options={configData && configData.sirketler}
                    />

                    <Field
                      name="islemNo"
                      label={t("davaIcraSavcilik.islemNo")}
                      colNumber="3"
                      component={TextInput}
                    />
                    {/* <Field
                      name="dosyaNo"
                      label={t("documentUpdate.dosyaNo")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    {/* <Field
                      name="departmanID"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.departmanlar}
                    /> */}
                    {/* <Field
                      name="dosyaTuruID"
                      label={t("davaIcraSavcilik.dosyaTuru")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.dosyaTurleri}
                    /> */}
                    <Field
                      name="talepTuruID"
                      label={t("demandTypes.talepTürü")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepTurleri}
                    />
                    

                    {/* <Field
                      name="avukatID"
                      label={t("report.gorevlendirilen")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.users}
                    /> */}
                    {/* <Field
                      name="dilID"
                      label={t("sozlesmeler.dil")}
                      colNumber="3"
                      component={Select}
                      options={configData && configData.diller}
                    /> */}
                    <Field
                      name="konu"
                      label={t("davaIcraSavcilik.konu")}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="isGucuBirimId"
                      label={t("demandUpdate.isGucuBirim")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.isGucu}
                    />
                    <Field
                      name="createdUser"
                      label={t("demandList.ekleyen")}
                      colNumber="3"
                      component={TextInput}
                    />
                    {/* <Field
                      name="talepbilgi"
                      label={t("demandList.talepBilgisi")}
                      colNumber="3"
                      component={TextInput}
                    /> */}
                    <Field
                      name="talepDurumuID"
                      label={t("demandStates.talepDurumu")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepDurumu}
                    />

                    <Field
                      name="acilisTarihiMin"
                      label={t("demandList.baslangicTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                    />
                    {/* <Field
                      name="bitisTarihi"
                      label={t("demandList.bitisTarihi")}
                      colNumber="3"
                      component={ReactDatePicker}
                    /> */}
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <DemandUpdate
        extraButton
        extraButtonOnClick={onReject}
        pageType={1}
        extraButtonText={t("actionButtonGenerator.red")}
        type={1}
        title={t("anaSayfa.bekleyenTalepler")}
        endpoint={"yonlendirilecek-talep/avukatAta"}
        okButtonText={t("actionButtonGenerator.atamaYap")}
        refreshList={refreshList}
        setRefreshList={setRefreshList}
        showModal={showModal}
        isUpdating={isUpdating}
        selectedRow={selectedRow}
        setShowModal={setShowModal}
        setRejectReason={setRejectReason}
      />
      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName=""            
            endpoint={(ikiliFormat) ? 'yonlendirilecek-talep/listele-tumu': 'yonlendirilecek-talep/listele' }
            keyField="id"
            refreshList={refreshList}
            customBody={{
              filters: filters,
            }}
            hideSelection={true}
            columns={[
              {
                dataField: "id",
                text: `${t("demandList.islemNo")}`,
                sort: true,
                headerStyle: {
                  width: 64
                }
              },
              // {
              //   dataField: "companyGroup",
              //   text: `${t("demandList.grup")}`,
              //   formatter: (data) => formatListWithParameter(data, "name"),

              //   sort: true,
              // },
              {
                dataField: "company.name",
                text: `${t("demandList.grupSirketi")}`,
                formatter: (data) => truncateText(data, 50, 40),
                sort: true,
              },
              {
                dataField: "talepTur.talepTuru",
                text: `${t("demandList.talepTuru")}`,
                sort: true,
              },
              
              {
                dataField: "konu",
                text: `${t("demandList.konu")}`,
                formatter: (data) => truncateText(data, 35, 30),
                sort: true,
              },
              {
                dataField: "",
                text: `${t("demandList.isGücüBirim")}`,
                formatter: (data, row) => (row.isGucuBirimi ? row.isGucuBirimiName : ""),
                sort: true,
              },
              {
                dataField: "cdate",
                text: `${t("demandList.talepTarihi")}`,
                formatter: formatShortDate,
                sort: true,
                headerStyle: {
                  width: 80
                }
              },
              {
                dataField: "createdUser.fullName",
                text: `${t("demandList.ekleyen")}`,
                sort: true,
              },
              // {
              //   dataField: "talepbilgi",
              //   text: `${t("demandList.talepBilgisi")}`,
              //   sort: true,
              // },
              {
                dataField: "talepDurum.talepDurumName",
                text: `${t("demandList.talepDurumu")}`,
                sort: true,
              },
              {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
              sort: false,
            },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EXCEL_EXPORT, {
                  requestTo: (ikiliFormat) ? 'file/download-excel-bekleyen-tumu': 'file/download-excel-bekleyen'
                }),
                addActiveFn(
                  pushToParams(
                    withNewTitleAndName(
                      ABT.EDIT,
                      "actionButtonGenerator.goruntule",
                      "EDIT_WITH_TITLE"
                    ),
                    onUpdateButtonClicked
                  ),
                  (row) => !row.departmanYoneticisiMi
                ),
                addActiveFn(
                  pushToParams(ABT.EDIT, onUpdateButtonClicked),
                  (row) => row.departmanYoneticisiMi
                ),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
